import { render } from "./LoadingAnimation.vue?vue&type=template&id=57179c52&scoped=true"
const script = {}

import "./LoadingAnimation.vue?vue&type=style&index=0&id=57179c52&lang=sass&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57179c52"]])

export default __exports__